import { FormInstance } from "antd";

import { AfBlobPath } from "../../../../graphql/operations/@types";
import { renderDecodedId } from "../../../../utils/renderDecodedId";
import { DrawerActionType } from "../../types";
import { denormalizeFeaturedEventsData } from "../utils/denormalizeData";
import { FeaturedEventsFormDataType } from "../types";

export default function handleSubmit({
  values,
  form,
  drawerAction,
  uploadFile,
  createFeaturedEvent,
  updateFeaturedEvent,
  refetch,
  setOpenDrawer,
}: {
  values: FeaturedEventsFormDataType;
  form: FormInstance<any>;
  drawerAction: DrawerActionType;
  uploadFile: any;
  createFeaturedEvent: any;
  updateFeaturedEvent: any;
  refetch: any;
  setOpenDrawer: (value: React.SetStateAction<boolean>) => void;
}) {
  const id = form.getFieldValue("id");
  const { originFileObj } = values.image[0] || {};

  if (originFileObj)
    uploadFile({
      variables: {
        blobs: [
          {
            file: originFileObj,
            path: AfBlobPath.TrialModeLocalEventFeaturedEventBanners,
          },
        ],
      },
    }).catch((e: any) => console.log(e));

  if (drawerAction === "Create")
    createFeaturedEvent({ variables: denormalizeFeaturedEventsData(values) })
      .then(() => {
        refetch()
          .then(() => {
            form.resetFields();
            setOpenDrawer(false);
          })
          .catch((e: any) => console.log(e));
      })
      .catch((e: any) => console.log(e));

  if (drawerAction === "Edit")
    updateFeaturedEvent({
      variables: {
        featuredEventId: parseInt(renderDecodedId(id)),
        ...denormalizeFeaturedEventsData(values),
      },
    })
      .then(() => {
        refetch();
        form.resetFields();
        setOpenDrawer(false);
      })
      .catch((e: any) => console.log(e));
}
